export default "__VITE_ASSET__s6v8cWON__"